import { FC, useRef, useState, useEffect } from "react";
import imageEmail from "../../../assets/images/emailImage.png";
import "./validate.css";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import useAuth from "../../../hooks/useAuth";
import { useAppConfig } from "../../../hooks/useAppConfig";

const ValidateCodeReset: FC = () => {
  const [code, setCode] = useState(["", "", "", ""]);
  const inputRefs = useRef<any>([]);
  const navigate = useNavigate();
  const { getToken } = usePluginspace();
  const [loading, setLoading] = useState(false);

  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const configData = await getAppConfig();
        if (configData?.webappcolor?.webappbutton) {
          setPrimaryColor(configData.webappcolor.webappbutton);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchConfig();
  }, []);

  const handleChange = (e: any, index: number) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      if (index < 3) {
        inputRefs.current[index + 1].focus();
      }
    } else if (value === "" && index > -1) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      inputRefs.current[index === 0 ? index : index - 1].focus();
    }
  };

  const validar = async () => {
    try {
      setLoading(true);
      const cpf = localStorage.getItem("cpfReset");
      const payload = {
        cpf: cpf,
        validationCode: code.join(""),
      };
      await api
        .post(`/api/customer/valid_code_password`, payload, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response: any) => {
          setLoading(false);
          const data = response.data;
          if (!data || !data.success) {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Erro na validação do código, tente novamente!",
            });
            return;
          }
          navigate("reset");
        })
        .catch((err: any) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro na validação do código, tente novamente!",
          });
          console.log(err);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      {loading ? (
        <div className="loading-container" style={{ backgroundColor: "#FFF" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="content-main">
          {/* Botão de Voltar Padronizado */}
          <button className="btn-back" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Voltar
          </button>

          <div className="validate-image">
            <img src={imageEmail} alt="Email" />
          </div>

          <div className="validate-header">
            <h1 style={{ color: primaryColor }}>Validar email</h1>
            <span>
              Enviamos uma mensagem para o seu email com um código de 4 dígitos.
            </span>
          </div>

          <div className="code-container">
            {code.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                className="digit-input"
                value={digit}
                onChange={(e) => handleChange(e, index)}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>

          <div className="msg-send-again">
            <span>Não recebeu a mensagem?</span>
            <a style={{ color: primaryColor }}>
              Clique aqui para enviar novamente
            </a>
          </div>

          <button
            className="btn-primary"
            style={{ background: primaryColor }}
            onClick={() => validar()}
          >
            Validar
          </button>
        </div>
      )}
    </>
  );
};

export { ValidateCodeReset };
